import { FormInstance } from "../../../models/site-content/form-instance.model";
import { HomePageActionDialogReturnObj, PerformActionParamObj } from "../extras";
import { HomePageActionBase } from "./home-page-base-action";
import { IHomePageAction } from "./i-home-page-action";
import { Form } from '../../../models/form-builder/form.model';
import { Folder } from '../../../models/site-content/folder.model';

export class CreateFormAction extends HomePageActionBase implements IHomePageAction {
    // Properties.
    private currentFolder: Folder = null;
    private formTemplate: Form = null;

    // Implement IHomePageAction methods.
    public getTitle() {
        return "New Form";
    }

    public permissionsRequiredToPerform(): string {
        return "CanCreateForm"
    }

    public requiresTree(): boolean {
        return true;
    }

    public requiresCurrentFolder(): boolean {
        return true;
    }
    public setCurrentFolder(folder: Folder): void {
        this.currentFolder = folder;
    }

    public requiresFormTemplate(): boolean {
        return true;
    }
    public setFormTemplate(formTemplate: Form): void {
        this.formTemplate = formTemplate;
    }
    public getSuggestedEntityName(): string {
        let suggestedName: string = null;

        // If we have our form template and the template is configured for auto-numbering, suggest a new form instance name.
        if ((this.formTemplate != null) && this.formTemplate.hasFormInstanceAutoNumberConfig()) {
            // Suggest a name.
            let folderName: string = this.currentFolder != null ? this.currentFolder.name : '';
            suggestedName = this.formTemplate.proposeAutoNumberName(this.formTemplate.numTemplateFormInstancesInFolder, folderName);
        }

        return suggestedName;
    }

    public performAction(paramObj: PerformActionParamObj): Promise<HomePageActionDialogReturnObj> {
        this.message = "Creating new Form...";
        let newForm = new FormInstance();
        newForm.name = paramObj.entityName;
        newForm.folderId = paramObj.folderId;
        newForm.dataCollectionId = this.siteId;
        newForm.formId = this.formId;
        return this.formInstanceService.create(newForm).then(res => {
            return this.formInstanceService.getContent(res.id, false).then(res => {
                return new HomePageActionDialogReturnObj(true, res);
            });
        });
    }

}
